import { store } from '@/store';

let loadingCount = 0;

export const showLoading = () => {
  if (navigator.onLine) {
    loadingCount++;
    window.setTimeout(() => {
      // Slight delay in case we call hideLoading immeadiately after because of an error or something of that nature.
      if (loadingCount > 0) {
        store.commit('isLoading', true);
      }
    }, 0);
  }
};

export const hideLoading = (forceLoadingCountToZero = false) => {
  loadingCount--;
  if (forceLoadingCountToZero) {
    loadingCount = 0;
  }
  window.setTimeout(() => {
    if (loadingCount <= 0) {
      loadingCount = 0;      
      store.commit('isLoading', false);
    }
  }, 50); // Anti FOUC delay.
};

export const showLoadingBloop = () => {
  store.commit('isLoading', true);
  window.setTimeout(() => {
    if (loadingCount <= 0) {
      store.commit('isLoading', false);
    }
  }, 1000);
};
